import { createReducer , on } from '@ngrx/store';
import { Menu, MenuItem } from 'src/app/models/menu/menu.models';
import { storeMenuItems } from 'src/app/store/actions/menu/menu.actions';
import { menuItems } from 'src/app/app.routes';

export interface menuState {
    Menu: Menu
}

export const initialMenuEntries : Menu = { items: []} ;

export const MenuReducer = createReducer(
    
    initialMenuEntries,

    on(storeMenuItems , (state , { userRoles })=>{

        return { 
        
            ...state, items:[
                
                ...menuItems.filter( ( item : MenuItem ) => {
                    
                    const { allowedRoles , active } = item || {};

                    if( active && (allowedRoles.length === 0 || isRoleIncluded(allowedRoles, userRoles)) ){
                        
                        const mySubItems = item.subItems && [...item.subItems].filter(( subItem: MenuItem) =>  {

                            const { allowedRoles } = subItem || {};

                            const roleCondition : boolean = subItem.active && (isRoleIncluded(allowedRoles, userRoles));
                            
                            return roleCondition ? subItem : null;
                        })

                        item.subItems = mySubItems;

                        return item
                    }

                    return null;
                })
            ]
        };
    }),
)

export const isRoleIncluded = ( allowedRoles: string[], userRoles: string[] ):boolean => {

    const isInclude: boolean = allowedRoles.some( role => userRoles.map((r:string) => r.toLocaleLowerCase()).includes( role ) );

    return isInclude;
}